// Instagram.tsx
import React from "react";
import styles from "./Instagram.module.css";

const InstagramIcon = () => {
  const handleClick = (event: React.MouseEvent<HTMLImageElement>) => {
    event.preventDefault();

    setTimeout(() => {
      const igWebUrl = "https://www.instagram.com/thehideawaycampingretreat/";
      window.open(igWebUrl, "_blank");
    }, 25);
  };

  return (
    <img
      onClick={handleClick}
      src="/icons/instagram_icon.png"
      alt="Instagram"
      className={styles.icon}
    />
  );
};

export default InstagramIcon;
